import { apiClient } from '../../../../v4/core/apiClient';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { createVisitorVendorStateApi } from '../../../api/visitor-vendor-state/visitor-vendor-state.api.http';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myEventService } from '../EventService/EventService.connected';
import { createVisitorVendorStateService } from './VisitorVendorStateService.impl';

export const myVisitorVendorStateService = createVisitorVendorStateService({
  api: createVisitorVendorStateApi(apiClient),
  queryClient,
  services: {
    errorService: myErrorService,
    eventService: myEventService
  }
});
